<template>
  <div class="pd-box">
    <div class="goods-img-box">
      <div class="goods-img">
        <img :src="_getPic(product.img || product.Logo, true)" class="goods-pic" alt="">
        <div v-if="product.IsOutBusinessScope" class="disable-type">{{ lang.Goods.Disabled_OverStep }}</div>
        <div v-else-if="product.IsSoldOut && fromPage == 'MyCollection'" class="disable-type">已下架</div>
        <div v-else-if="(!product.Stock || product.Stock <= 0) && !product.IsSoldOut && fromPage != 'isArriving' && !product.EstimatedTime" class="disable-type">
          {{ lang.Goods.Disabled_Undercarriage }}
        </div>
      </div>
      <!-- 倒计时显示不同的颜色 -->
      <div
        v-if="firstTime.length > 0 && timer.type != 2"
        class="goods-timer"
        :class="{
          'img-bs1': product.NewProductTime,
          'img-bs2': false,
          'img-bs3': product.EstimatedTime && !product.NewProductTime && !product.Stock
        }"
      >
        <span v-if="product.NewProductTime">新品抢购仅剩{{ firstTime[3] }}天{{ firstTime[0] }}时{{ firstTime[1] }}分</span>
        <span v-else-if="product.EstimatedTime && getMomentStatus() && !product.Stock">预计到货日期{{ firstTime[3] }}天</span>
      </div>
      <!-- 进行中结束倒计时 -->
      <div
        v-if="(timer.type == 2 || timer.type == 1) && !getMomentStatus()"
        :class="{
          'goods-timer': true,
          'img-bs2': product.GoodsActivityCountdown !== null && product.GoodsActivityCountdown.countdownType === 1,
          'img-bs1-c': product.GoodsActivityCountdown !== null && product.GoodsActivityCountdown.countdownType !== 1
        }"
      >
        <!-- <span
					v-if="product.GoodsActivityCountdown !== null && product.GoodsActivityCountdown.countdownType === 1">
					{{ timer.type == 2 ? '特价活动' : '距活动开始' }}仅剩{{ timer.d }}天{{ timer.h }}时{{ timer.m }}分
				</span> -->
        <div v-if="product.GoodsActivityCountdown !== null && product.GoodsActivityCountdown.countdownType === 1" class="active-time no-start-colon">
          {{ timer.type == 2 ? '特价活动' : '距活动开始' }}仅剩{{ timer.d }}天
          <van-count-down :time="product.GoodsActivityCountdown.TotalMilliseconds">
            <template #default="timeData">
              <span class="block no-start-block">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</span>
              <span class="colon no-start-colon">:</span>
              <span class="block no-start-block">{{ timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes }}</span>
              <span class="colon no-start-colon">:</span>
              <span class="block no-start-block">{{ timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds }}</span>
            </template>
          </van-count-down>
        </div>
        <!-- <span v-else>{{ timer.type == 2 ? '特价活动' : '距活动结束' }}仅剩{{ timer.d }}天{{ timer.h }}时{{ timer.m }}分</span> -->
        <div v-else class="active-time">
          {{ timer.type == 2 ? '特价活动' : '距活动结束' }}仅剩{{ timer.d }}天
          <van-count-down :time="product.GoodsActivityCountdown.TotalMilliseconds">
            <template #default="timeData">
              <span class="block">{{ timeData.hours > 9 ? timeData.hours : "0" + timeData.hours }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds }}</span>
            </template>
          </van-count-down>
        </div>
      </div>

      <!-- 商品活动类型 -->
      <!-- <div
				class="goods-class"
				v-if="product.ActivityPresentList && product.ActivityPresentList.length && this.product.ActivityPresentList[0].ConditionType && !getMomentStatus()"
				:class="{ 'goods-bs1': true }"
			>
				<div class="left">{{ product.ActivityPresentList[0].ConditionType == 2 || product.ActivityPresentList[0].ConditionType == 1 ? '满赠' : '多买优惠' }}</div>
				<div class="ellips-text right">{{ changeString(product.ActivityPresentList) }}</div>
			</div>
			<div class="goods-class" v-else-if="product.ActivityPresentList.length && !getMomentStatus()" :class="{ 'goods-bs2': true }">
				<div class="left">{{ '满减' }}</div>
				<div class="ellips-text right">{{ changeString(product.ActivityPresentList) }}</div>
			</div>
			<div class="goods-class" v-else-if="product.CommodityCouponPackages.length" :class="{ 'goods-bs1': true }">
				<div class="left">{{ '领券' }}</div>
				<div class="ellips-text right">{{ product.CommodityCouponPackages[0].Name }}</div>
			</div> -->
      <div v-if="product.ActivityPresentList && product.ActivityPresentList.length && this.product.ActivityPresentList[0].ConditionType && !getMomentStatus()" class="goods-class" :class="{ 'goods-bs1': true }">
        <span class="goods-class-lable goods-class-lable-padding">
          {{ product.ActivityPresentList[0].ConditionType == 2 || product.ActivityPresentList[0].ConditionType == 1 ? '满赠' : '多买优惠' }}
        </span>
      </div>
      <div v-else-if="product.ActivityPresentList.length && !getMomentStatus()" class="goods-class" :class="{ 'goods-bs2': true }">
        <span class="goods-class-lable goods-class-lable-padding">满减</span>
      </div>
      <div v-else-if="product.CommodityCouponPackages.length && !product.GoodsActivityCountdown" class="goods-class" :class="{ 'goods-bs1': true }">
        <span class="goods-class-lable">
          <em>领券</em>
          {{ product.CommodityCouponPackages[0].Name }}
        </span>
      </div>
      <!--
				控销
			 -->
      <div
        v-if="product.ActivityPresentList.length === 0 && !product.SourceGoodsSkuId && product.MarketControlInfo"
        :class="{
          'goods-timer': true,
          'goods-bs1-c': product.MarketControlInfo && product.MarketControlInfo.IsOverControlTime,
          'img-bs1-c': product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime && product.MarketControlInfo.WillFreeControlDays < 15,
          'img-bs1-t': product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime && product.MarketControlInfo.WillFreeControlDays >= 15
        }"
      >
        <span
          v-if="product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime"
          :class="{
            controlpin: product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime && product.MarketControlInfo.WillFreeControlDays < 15,
            controlpin_nomal: product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime && product.MarketControlInfo.WillFreeControlDays >= 15
          }"
        >
          <span class="controlpin_nomal">距控销释放还剩：</span>
          {{ product.MarketControlInfo.WillFreeControlDays }}天
        </span>
        <span v-else class="controlpin">
          <span class="controlpin_nomal">已过释放期，</span>
          {{ product.MarketControlInfo.WillLoseControlDays }}天后将失去控销权
        </span>
      </div>
    </div>
    <div>
      <div class="goods-tag-name">
        <!-- 医保标签标签 -->
        <div v-for="properties in product.CommodityListProperties" v-if="properties.AttributeName == '医保类型'" :key="properties.Id" style="font-size: 0;margin-right: 4px;">
          <img v-if="properties.Value == 1" src="../assets/goods/class_a.png" width="28px" height="16px">
          <img v-if="properties.Value == 2" src="../assets/goods/class_b.png" width="28px" height="16px">
          <img v-if="properties.Value == 3" src="@/assets/goods/yibao.png" width="28px" height="16px">
        </div>
        <!-- 活动标签 -->
        <div v-if="product.ActivityTags && product.ActivityTags.length" class="goods-tag "><img :src=" product.ActivityTags[0].Img" style="height: 16px;"></div>

        <!-- 新品标签 -->
        <!-- <div class="goods-tag tag-new" v-if="product.NewProductTime && moment().isBefore(moment(product.NewProductTime)) && !ActivityTags.length">新品</div> -->
        <div v-if="product.NewProductTime && moment().isBefore(moment(product.NewProductTime)) && !ActivityTags.length" style="font-size: 0; margin-right: 4px;">
          <img src="../assets/goods/new.png">
        </div>

        <!-- 商品标签 -->
        <div v-if="GoodsTags.length" class="goods-tag "><img :src="GoodsTags[0].Img" style="width: 32px;height: 16px;"></div>

        <div class="goods-name ellips-text">{{ product.OperationName || product.SkuName }}</div>
      </div>
      <div class="goods-msg-item ellips-text">规格：{{ product.Specifications }}</div>
      <template v-for="properties in product.CommodityListProperties">
        <div v-if="properties.AttributeName == '效期优于'" :key="properties.Id" class="goods-msg-item ellips-text">
          {{ properties.Abbreviation == '效' ? '效期优于：' + properties.Value : properties.Value }}
        </div>
      </template>
      <!-- 价格区块 -->
      <div v-if="!product.IsOutBusinessScope" class="goods-price">
        <template v-if="product.PriceActivity">
          <span v-if="product.IsShowOriginalPrice && product.SourceGoodsSkuId" class="old-money fAvenirH">¥ {{ product.Price }}</span>
          <!-- 活动标签 -->
          <!-- <div class="goods-tag " v-if="ActivityTags.length">
						<img :src="ActivityTags[0].Img" style="width: 32px;height: 16px;">
					</div> -->
          <div class="new-money">
            <span class="text">优惠价</span>
            <!-- <span class="value" v-if="product.GoodsActivityCountdown !== null && product.GoodsActivityCountdown.countdownType === 1">
                                        ¥1
                                        {{
                                            product.PriceActivity.toFixed(2)
                                                .toString()
                                                .replace(/[0-9]/gi, '?')
                                        }}
                                    </span> -->
            <span class="value">¥ {{ product.PriceActivity.toFixed(2) }}</span>
          </div>
        </template>
        <span v-else class="money fAvenirH">¥ {{ product.PriceLimit }}</span>
      </div>
      <!-- /.end 价格 -->
      <div v-if="!product.IsOutBusinessScope" class="goods-disc">
        <span>
          最低零售价 ¥{{ Number(product.RetailPrice).toFixed(2) }} | 毛利率
          {{ _showProductProfit(product.RetailPrice, _getProductPrice(product.PriceActivity, product.PriceLimit)) + '%' }}
        </span>
      </div>

      <!-- 商品底部 -->
      <div v-if="parseInt(product.Stock) <= 0 && !product.IsOutBusinessScope" class="goods-bottom" @click.stop="getCollect(Enum_CollectType.Subscribe)">
        <!--  :disabled="product.ArrivalNotices" -->
        <a-button type="primary" class="get-goods">{{ product.ArrivalNotices ? '已订阅' : '到货通知' }}</a-button>
      </div>
      <div v-if="!product.IsOutBusinessScope && parseInt(product.Stock) > 0 && product.OutPurchaseAgreementDto" class="goods-bottom">
        <div style="flex:1" @click.stop="clickStop">
          <van-stepper v-model="cartNum" :min="product.OutPurchaseAgreementDto.PurchaseNumber" :disable-plus="cartNum >= product.Stock || (product.LimitPerOrder && cartNum >= product.LimitPerOrder)" :step="product.OutPurchaseAgreementDto.StepLengthNumber" integer />
        </div>
        <div v-if="product.GoodsActivityCountdown && product.GoodsActivityCountdown.countdownType === 1 && product.SourceGoodsSkuId !== null">
          <a-button type="primary" class="join-btn-ready">即将开始</a-button>
        </div>
        <div v-else>
          <!-- <a-button
						:type="
							product.ActivityPresentList.length === 0 && !product.SourceGoodsSkuId && product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime
								? 'primary'
								: 'danger'
						"
						:class="
							product.ActivityPresentList.length === 0 && !product.SourceGoodsSkuId && product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime
								? 'get-goods'
								: 'join-btn'
						"
						@click.stop="confirmCart"
					>
						{{
							product.ActivityPresentList.length === 0 && !product.SourceGoodsSkuId && product.MarketControlInfo && product.MarketControlInfo.IsOverControlTime
								? '优先控销'
								: product.ActivityPresentList.length === 0 && !product.SourceGoodsSkuId && product.MarketControlInfo && !product.MarketControlInfo.IsOverControlTime
								? '控销'
								: '加入购物车'
						}}
					</a-button> -->
          <a-button type="danger" class="join-btn" @click.stop="confirmCart">加入购物车</a-button>
        </div>
      </div>
      <div v-if="product.IsOutBusinessScope" class="err-bottom"><span>超出经营范围</span></div>
    </div>
    <!-- 条件弹框 -->
    <!-- 参与条件弹窗 -->
    <div v-if="conditionModal" class="modal-box">
      <div class="modal-content">
        <div class="cond-bg">
          <div class="title">参与条件</div>
          <div class="disc">您暂时未满足该专区活动参与条件，如要参与需满足以下条件：</div>
          <div v-if="!!product.RuleText" class="content">
            <div class="list">
              <p v-for="(ruleItem, ruleIndex) in product.RuleText.split(';')" :key="ruleIndex" style="margin:0;">
                {{ ruleIndex + 1 }}、{{ ruleIndex > 0 ? product.ConditionRelation : '' }}{{ ruleItem }}。
              </p>
            </div>
          </div>
          <button class="btn" @click.stop="conditionModal = false">知道啦～</button>
        </div>
        <div class="close-box">
          <a-icon type="close-circle" class="icon-close" @click.stop="conditionModal = false" />
        </div>
      </div>
    </div>
    <!-- 不满足条件弹窗 -->
    <div v-if="joinModal" class="modal-box">
      <div class="modal-content">
        <div class="ncond-bg">
          <div class="title">温馨提示</div>
          <div class="disc">
            <div>您暂时未满足该活动参与条件，</div>
            <div>是否以原价购买该商品？</div>
          </div>
          <button class="btn" @click.stop="oldBuy">以原价购买</button>
          <button class="btn btn-s2" @click.stop="lookCond">查看参与条件</button>
        </div>
        <div class="close-box">
          <a-icon type="close-circle" class="icon-close" @click.stop="joinModal = false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { BaseMixin } from '@/mixins/BaseMixin'
import { CollectType } from '@/dictionary/goods.js'

export default {
  mixins: [BaseMixin],
  props: {
    timer: {
      type: Object,
      default: () => {
        return {}
      }
    },
    ActivityTags: {
      type: Array,
      default: () => []
    },
    GoodsTags: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    },
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fromPage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      // 不满足参加专区活动的弹窗显示
      joinModal: false,
      // 不满足参加条件的提示弹窗显示
      conditionModal: false,
      isOldBuy: false, // 是否原价购买
      value: 1,
      Enum_CollectType: CollectType,
      firstTime: [],
      color: ['red', 'orange', 'blue', 'green'],
      goodsActivity: {},
      timerFun: {},
      collects: {
        Goods: { Id: '', IsCollect: false },
        Subscribe: { Id: '', IsCollect: false }
      },
      IsAccord: true,
      cartNum: 0,
      url: {
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart',
        createLike: '/api_customer/CustomerCollect/Create', // 客户收藏&订阅到货通知
        deleteLike: '/api_customer/CustomerCollect/PhysicalDeleteBatch', // 客户取消收藏&到货通知
        getCollect: '/api_customer/CustomerCollect/IsCollect' // 是否收藏&订阅
      }
    }
  },
  watch: {
    product: {
      handler(val) {
        // 有门槛活动商品判断是否有购买权限
        const { IsAccord = true } = val
        if (typeof IsAccord === 'boolean') {
          this.IsAccord = IsAccord
        }
      },
      immediate: true,
      deep: true
    },
    isOldBuy: {
      handler(val) {
        if (val) {
          // console.log('以原价')
          this.confirmCart()
        }
      }
    }
  },
  created() {
    this.goodsActivity = this._analysisGoodsActivity(this.product.SalesPromotions)
    this.product.goodsActivity = this.goodsActivity
    // 倒计时显示顺序  即将到货 < 新品 < 特价
    let productTime = this.product.NewProductTime

    if (!this.product.NewProductTime) {
      productTime = this.product.EstimatedTime
    } else if (this.fromPage == 'isArriving') {
      productTime = this.product.EstimatedTime
    } else if (this.goodsActivity) {
      productTime = this.goodsActivity.FirstEnd.EndTime
    }

    const timer = productTime => {
      const array = this._analysisActivityDiffTime(productTime, moment())
      const firstTime = this._setTimerArr(array[1])
      let flag = true
      const constDays = array[0].length > 1 ? array[0] : '0' + array[0]
      firstTime.push(constDays)
      firstTime.push(array[0])
      firstTime.forEach(t => {
        if (Number(t) < 0) {
          clearInterval(this.timertimerFun)
          flag = false
        }
      })
      if (flag) {
        this.firstTime = firstTime
      }
    }

    if (productTime) {
      timer(productTime)
      this.timerFun = setInterval(timer(productTime), 1000)
    }
  },
  methods: {
    moment,
    oldBuy() {
      // 改变状态转入商品组件，以便采用原始ID购买
      this.isOldBuy = true
      // 关闭弹窗
      this.joinModal = false
      // 改变为可以购买
      this.IsAccord = true
    },

    // 查看参与条件
    lookCond() {
      this.joinModal = false
      this.conditionModal = true
    },
    showBuyModal() {
      this.joinModal = true
    },
    getMomentStatus() {
      const { EstimatedTime } = this.product
      return moment().isBefore(moment(EstimatedTime))
    },
    // 转换字
    changeString(str) {
      if (!str || !str.length) {
        return
      }
      const { ConditionType, Full, DiscountType, presentList = [] } = str[0]
      if (ConditionType) {
        const showGift = presentList ? presentList[0] : {}
        let string = ''
        string = ConditionType == 1 ? '满' : ConditionType == 2 ? '每满' : ConditionType == 3 ? '买' : '每买'
        string = string + (Full || '')
        string = string + (DiscountType == 1 ? '元' : DiscountType == 2 ? '' : '盒')
        if (Object.keys(showGift).length) {
          const { Unit = '', Amount = 1, Name } = showGift
          if (Unit) {
            // 赠品有单位
            string = string + '送' + Amount + Unit + Name
          } else {
            // 赠品无单位
            string = string + '送' + Name + '*' + Amount
          }
        }
        // console.log(string);
        return string.length > 18 ? string.substring(0, 16) + '..' : string
      } else {
        let showMsg = '指定商品'
        if (str.length) {
          str.forEach((element, index) => {
            showMsg += this.getSendActiveText(element)
            if (index < str.length - 1) {
              showMsg += '，'
            }
          })
        }
        return showMsg.length > 18 ? showMsg.substring(0, 18) + '...' : showMsg
      }
    },
    getSendActiveText(showDefaultConfig) {
      let giftTypeMsg = ''
      const { Present: Discount, DiscountType, presentList: ActivityConfigPresent, Full: Condition, Type: ActivityType } = showDefaultConfig
      giftTypeMsg += `${
        // ActivityType === 1 ? "指定商品订单金额" : "指定专区商品订单金额"
        ActivityType === 1 ? '' : ''
      }`
      // 未满足时
      giftTypeMsg += '满'
      giftTypeMsg += Condition
      giftTypeMsg += '元'
      // 条件值类型   折扣 = 2, 金额 = 1,
      if (DiscountType) {
        giftTypeMsg += DiscountType == 1 ? '减' : '总价打'
      }
      if (Discount) {
        giftTypeMsg += Discount
      }
      if (DiscountType && DiscountType === 2) {
        giftTypeMsg += '折'
      }
      giftTypeMsg += this.getGiftContent(ActivityConfigPresent)
      return giftTypeMsg
    },
    getGiftContent(giftArr) {
      if (!giftArr || !giftArr.length) {
        return ''
      }
      let giftShowContent = '，并赠送'
      giftArr.forEach((item, index) => {
        giftShowContent += `${item.Name ?? ''}*${item.Amount}${index < giftArr.length - 1 ? '、' : ''}`
      })
      return giftShowContent
    },
    clickStop() { },
    // 确认购物车
    async confirmCart() {
      // 判断购买资格
      const { IsAccord, isOldBuy = false } = this
      if (!IsAccord && !isOldBuy) {
        this.showBuyModal()
        return
      }

      if (!!this.product.LimitPerOrder && this.cartNum > this.product.LimitPerOrder) {
        this.$toast({
          position: 'bottom',
          message: '单笔订单限购（' + this.product.LimitPerOrder + '）' + this.product.Unit
        })
        const rightCartNum = this.$hys.checkLimitPerOrder(
          this.product.OutPurchaseAgreementDto.PurchaseNumber,
          this.product.OutPurchaseAgreementDto.StepLengthNumber,
          this.product.LimitPerOrder
        )
        if (rightCartNum > this.product.OutPurchaseAgreementDto.PurchaseNumber) {
          this.cartNum = rightCartNum
        } else {
          this.cartNum = this.product.OutPurchaseAgreementDto.PurchaseNumber
        }
        console.log(this.cartNum)
        return
      }
      if (this.cartNum > this.product.Stock) {
        this.$toast({
          position: 'bottom',
          message: '购买商品数量超过了该商品库存，库存余（' + this.product.Stock + '）'
        })
        this.cartNum = this.product.Stock
        return
      }
      this.product.cartNum = this.cartNum
      const toastLoading = this.$toast.loading({
        message: '',
        duration: 0,
        forbidClick: true
      })
      const res = await this.postAction(this.url.addOrUpdateCart, {
        ProductSKUId: this.product.Id,
        Count: this.product.cartNum,
        IsAdd: true,
        SourceGoodsSkuId: this.product.SourceGoodsSkuId,
        IsPrice: isOldBuy
      })
      if (res.IsSuccess) {
        toastLoading.clear()
        this.$nextTick(() => {
          if (res.Data.CountData) {
            // 判断是否可以加购
            if (res.Data.IsLimitPerOrder) {
              this.$toast({
                position: 'bottom',
                message: '单笔订单限购（' + this.product.LimitPerOrder + '）' + this.product.Unit
              })
              return false
            }
            this.$bus.$emit('buycarChanged', res.Data.CountData.ProductCount, true)
            this.$bus.$emit('rightBuycarChanged', res.Data.CountData.ProductCount, true)
          }
          this.$toast({
            position: 'center',
            message: '添加购物车成功'
          })
        })
      } else {
        toastLoading.clear()
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 操作订阅收藏
    async operateCollect(collectType) {
      const key = collectType == this.Enum_CollectType.Goods ? 'Goods' : 'Subscribe'
      const isCollect = this.collects[key].IsCollect
      const collectId = this.collects[key].Id
      if (isCollect) {
        this.cancelCollect(collectType, key, collectId)
      } else {
        this.setCollect(collectType, key)
      }
    },
    // 订阅&收藏
    async setCollect(collectType, key) {
      const title = collectType == this.Enum_CollectType.Goods ? '收藏成功' : '订阅成功'
      const data = {
        CollectType: collectType,
        CollectingBusinessId: this.product.Id,
        CollectionPrice: this._getProductPrice(this.product.PriceActivity, this.product.PriceLimit)
      }
      const res = await this.postAction(`${this.url.createLike}`, data)
      // console.log('收藏订阅', res)
      if (res.IsSuccess) {
        this.collects[key].Id = res.Data
        this.collects[key].IsCollect = true
        this.product.ArrivalNotices = true
        this.$toast(title)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 取消订阅&收藏
    async cancelCollect(collectType, key, collectId) {
      const title = collectType == this.Enum_CollectType.Goods ? '取消收藏成功' : '取消订阅成功'
      this.$hys.openLoading()
      const res = await this.deleteAction(`${this.url.deleteLike}?ids=${collectId}`)
      this.$hys.clearLoading()
      // console.log('取消收藏订阅', res)
      if (res.IsSuccess) {
        this.collects[key].Id = ''
        this.collects[key].IsCollect = false
        this.product.ArrivalNotices = false
        this.$toast(title)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    async getCollect(collectType) {
      const res = await this.getAction(`${this.url.getCollect}?collectingBusinessId=${this.product.Id}`)
      // console.log('获取收藏订阅详情', res)
      if (res.IsSuccess) {
        const data = res.Data
        const goodsCollects = data.filter(item => item.CollectType == this.Enum_CollectType.Goods)
        const subscribeCollects = data.filter(item => item.CollectType == this.Enum_CollectType.Subscribe)
        if (goodsCollects.length > 0) {
          this.collects['Goods'].Id = goodsCollects[0].Id
          this.collects['Goods'].IsCollect = true
        }
        if (subscribeCollects.length > 0) {
          this.collects['Subscribe'].Id = subscribeCollects[0].Id
          this.collects['Subscribe'].IsCollect = true
          this.product.ArrivalNotices = true
        }
        this.operateCollect(collectType)
      } else {
        //   this.$toast(res.Msg)
      }
    }
  }
}
</script>

<style scoped lang="less">
.modal-box {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  text-align: center;
}

.close-box {
  color: #fff;
  margin-top: 20px;
}

.icon-close {
  cursor: pointer;
  font-size: 30px;
}

.ncond-bg {
  width: 372px;
  background: url("../assets/activity-m.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 24px 32px;
}

.cond-bg {
  width: 544px;
  background: url("../assets/activity-m.png");
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 16px;
}

.modal-content {
  .title {
    color: #fff;
    font-size: 26px;
    text-align: center;
  }

  .disc {
    color: #fff;
    text-align: center;
    margin-top: 8px;
  }

  .content {
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px #7fabff;
    border-radius: 12px;
    padding: 16px;
    margin-top: 20px;

    .list {
      margin-bottom: 8px;
      color: #111a34;
      text-align: left;
    }
  }

  .btn {
    width: 261px;
    height: 40px;
    background: linear-gradient(180deg, #ffec32 0%, #ffd417 100%);
    border-radius: 22px;
    color: #111a34;
    cursor: pointer;
    border: 0;
    margin-top: 12px;
  }

  .btn-s2 {
    background: #fff;
  }
}

.pd-box {
  background: #ffffff;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 8px;
  width: 100%;
  text-align: left;
  height: 100%;
}

/deep/ .van-stepper__minus {
  background: #fff;
  border-radius: 2px 0px 0px 2px;
  border: 1px solid #c5cad5;
}

/deep/ .van-stepper__input {
  border-top: 1px solid #c5cad5;
  border-bottom: 1px solid #c5cad5;
  background: #fff;
  margin: 0;
}

/deep/ .van-stepper__plus {
  border-radius: 0 2px 2px 0;
  border: 1px solid #c5cad5;
  background: #fff;

  &:active {
    background-color: #c5cad5;
  }
}

.pd-box:hover .goods-pic {
  transform: scale(1.05);
}

.goods-pic {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}

.img-bs1 {
  background: #ff7575;
  // background: #FFEAE7;
}

.active-time {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ff3939;
}

.colon {
  display: inline-block;
  margin: 0 2px;
  color: #ff3939;
}

.no-start-colon {
  color: #f98900;
}

.block {
  display: inline-block;
  width: 17px;
  height: 17px;
  color: #fff;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  background-color: #ff3939;
  border-radius: 3px;
}

.no-start-block {
  background-color: #f98900;
}

.img-bs1-c {
  // background: #ff7575;
  background: #ffeae7;
}

.img-bs1-t {
  background-color: #ebf0f9;
}

.goods-bs1-c {
  // background: #ff7575;
  background: #ffeae7;
}

.no_controlpin {
  color: #ff3939;
}

.controlpin {
  color: #ff3939;
}

.controlpin_nomal {
  color: #111a34;
}

.img-bs2 {
  background: #fff3e5;
}

.img-bs3 {
  background: #ebf0f9;
  color: #111a34 !important;
}

.goods-bs1 {
  // background: linear-gradient(328deg, #ff6831 0%, #f3180e 100%);
  background: #f3f5f8;
  box-shadow: 0 0 12px #ffffff;
}

.goods-bs2 {
  // background: linear-gradient(328deg, #4898ff 0%, #0f6eea 100%);
  background: #f3f5f8;
  box-shadow: 0 0 12px #ffffff;
}

.goods-class {
  // width: 100%;
  // height: 28px;
  // border-radius: 8px 8px 0px 0px;
  // position: absolute;
  // z-index: 1;
  // left: 0;
  // bottom: 0;
  // line-height: 28px;
  // padding: 0 12px;
  // box-sizing: border-box;
  // display: flex;
  // color: #fff;
  // font-size: 12px;
  width: 100%;
  height: 28px;
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  line-height: 28px;
  padding: 0 6px;
  box-sizing: border-box;
  color: #ff3939;
  font-size: 12px;
}

.goods-class .left {
  margin-right: 8px;
}

.goods-class .right {
  flex: 1;
  width: 0;
}
.goods-class .goods-class-lable {
  border: 1px solid #ff3939;
  border-radius: 2px;
  padding: 0 4px 0 0;
}
.goods-class .goods-class-lable-padding {
  padding: 0 4px;
}
.goods-class .goods-class-lable em {
  font-style: normal;
  padding: 0 4px;
  background: linear-gradient(137deg, #ff6831 0%, #f3180e 100%);
  color: #ffffff;
}

.goods-timer {
  text-align: center;
  width: 100%;
  height: 28px;
  border-radius: 8px 8px 0px 0px;
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  line-height: 28px;
  padding: 0 12px;
  box-sizing: border-box;
  font-size: 12px;
  color: #fff;
}

.goods-img-box {
  position: relative;
  width: 100%;
  height: 210px;
  background: #f3f5f8;
  overflow: hidden;
}

.disable-type {
  width: 129px;
  height: 129px;
  background: rgba(17, 26, 52, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: 0.65;
}

.goods-img {
  width: 100%;
  height: 210px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ellips-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.goods-tag-name {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.goods-tag {
  border-radius: 4px;
  margin-right: 4px;
  font-size: 12px;
  color: #fff;
  // padding: 2px 4px;
  line-height: 1;
}

.tag-spe {
  background: #f98900;
}

.tag-new {
  background: #490fea;
}

.goods-name {
  color: #111a34;
  font-size: 16px;
  font-weight: bold;
  flex: 1;
}

.get-goods {
  width: 100%;
  height: 28px;
  border-radius: 2px;

  &:active {
    &::before {
      display: block;
      content: "";
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      background-color: #0250c4;
    }
  }
}

.err-bottom {
  color: #0f6eea;
  font-size: 16px;
  margin-top: 14px;
}

.goods-msg-item {
  color: #666f83;
  margin-top: 4px;
  line-height: normal;
}

.money {
  color: #ff3939;
  font-size: 20px;
  margin-right: 8px;
  // font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
}

.new-money {
  height: 20px;
  background: linear-gradient(137deg, #ff6831 0%, #f3180e 100%);
  border-radius: 4px;
  color: #fff;
  line-height: 20px;
  display: flex;
  align-items: center;
  padding: 0 6px;
}

.new-money .text {
  font-size: 12px;
  margin-right: 4px;
}

.new-money .value {
  font-size: 16px;
}

.old-money {
  color: #858b9c;
  text-decoration: line-through;
  margin-right: 8px;
}

.goods-price {
  margin-top: 10px;
  display: flex;
}

.goods-disc {
  color: #666f83;
  font-size: 12px;
  margin-top: 4px;
}

.goods-bottom {
  margin-top: 14px;
  display: flex;
  align-items: center;
}

.join-btn {
  background: #ff3939;
  border-radius: 2px;
  height: 28px;
}

.join-btn-ready {
  border-radius: 2px;

  height: 28px;
}
</style>
